import React, { Component } from "react";
import M from "materialize-css";
import { connect } from "react-redux";
import "./Footer/styles.css";

class Result extends Component {
	componentDidMount() {
		const elems = document.querySelectorAll(".collapsible");
		const instances = M.Collapsible.init(elems);
	}

	componentWillUnmount() {}
	render() {
		const { data, langBase } = this.props;
		const time = data.czas ? data.czas.split("-") : [ "error", "error" ];
		const services = data.services.map((service, i) => {
			return (
				<span key={i} style={{ display: "block" }}>
					<span className="name">{service.name}</span>
					<span className="info">{service.info}</span>
				</span>
			);
		});
		return (
			<div
				style={{
					maxHeight: "320px",
					overflowY: "scroll"
				}}>
				<ul className="collapsible popout">
					<li className="active">
						<div className="collapsible-header">
							<i className="material-icons">voice_chat</i>
							{langBase.il9n.yourTeam}
						</div>
						<div className="collapsible-body">
							<p className="s-title">
								<strong>
									<i className="material-icons tiny">fiber_manual_record</i>
									{data.ekipa}
								</strong>
							</p>
							<p>{langBase.il9n[data.ekipa_desc]}</p>
							{/* time */}
							<p className="s-title">
								<strong>
									<i className="material-icons tiny">fiber_manual_record</i>
									{langBase.il9n.yourTime}
								</strong>
							</p>
							<p>
								{" "}
								{langBase.il9n.yourTimeFrom}
								<strong> {time[0].trim().toLowerCase()} </strong>
								{langBase.il9n.yourTimeTo}
								<strong> {time[1].trim().toLowerCase()} </strong>
							</p>
							{/* additional */}
							<p className="s-title">
								<strong>
									<i className="material-icons tiny">fiber_manual_record</i>
									{langBase.il9n.yourAdditional}
								</strong>
							</p>
							<p>{services.length ? services : langBase.il9n.noAdditional}</p>
						</div>
					</li>
				</ul>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	langBase: state.langBase
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Result);
